// import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import {
	AccountantsRoutes,
	AccountiungProfessionalInitialRoutes,
	AccountiungProfessionalPADInitialRoutes,
	AccountiungProfessionalUDInitialRoutes,
	BCEHTSettingRoutes,
	BankRoutes,
	BillingProfileAssociationRoutes,
	BillingProfileRoutes,
	BranchRoutes,
	CityRoutes,
	ClientRoutes,
	CompanyRoutes,
	ComplianceRoutes,
	CountryRoutes,
	DataRoleRoutes,
	DirectDepositRoutes,
	EmployeeRoutes,
	ForgetPasswordRoutes,
	GlobalSearchRoutes,
	GlobalVariablesRoutes,
	MinimumWageRateRoutes,
	PDFSettingsRoutes,
	PayrollCSSTEarningsRoutes,
	PayrollEHTEarningsRoutes,
	PayrollEarningsRoutes,
	PayrollFederalEarningsRoutes,
	PayrollHSFEarningsRoutes,
	PayrollHolidayEarningsRoutes,
	PayrollInsurableEarningsRoutes,
	PayrollPensionableEarningsRoutes,
	PayrollProvincialTaxableEarningsRoutes,
	PayrollQPIPEarningsRoutes,
	PayrollRoutes,
	PayrollVocationalEarningsRoutes,
	PayrollWCBWSIBEarningsRoutes,
	ProvinceRoutes,
	ReportsRoutes,
	RoleManagementRoutes,
	SettingsRoutes,
	SingleCompanyInitialRoutes,
	StateRoutes,
	StatutoryHolidayRoutes,
	TD1FormRoutes,
	TD1Routes,
	TaxProfileRoutes,
	TaxYearRoutes,
	TaxesRoutes,
	VouchersRoutes,
	WebROESubmissionRoutes,
	WorkplaceSafetyRoutes,
	clientDashboardInitialRoutes,
	clientSetupDashboardInitialRoutes,
	initialLoadingPageWhileMenuIsGettingFromAPI,
	nonSuperUserInitialRoutes,
	nonSuperUserInitialRoutesIfAccAssign,
	routes,
	superUserInitialAccountantSetupRoutes,
	superUserInitialClientListRoutes,
	AddOnsRoutes,
	NewsRoutes,
} from "./routes";
import {
	PrivateRoute,
	ProtectedRoutes,
	PublicRoute
} from "@websential/cosmic-v20";
import React, { useMemo } from "react";
import { RoleRouteGuard, extractMenuUrls } from "../../common/Common";
import { Route, HashRouter as Router, Routes, useLocation } from "react-router-dom";

import { AccountOrBankDetailsPage } from "../../pages/AccountOrBankDetailsPage";
import { AddPhoneValidation } from "../../pages/Anonymous/AddPhoneValidation";
import { AuthSelectionScreenForLoginPage } from "../../pages/Anonymous/AuthSelectionScreenForLoginPage";
import { AuthSelectionScreenPage } from "../../pages/Anonymous/AuthSelectionScreenPage";
import { BackupCodeVerificationPage } from "../../pages/Anonymous/BackupCodeVerificationPage";
import { CreateAnAccountPage } from "../../pages/Anonymous/CreateAnAccountPage";
import { Generate2FaQrPage } from "../../pages/Anonymous/Generate2FaQrPage";
import { IAppState } from "../../store/reducers";
import { InviteUsersPage } from "../../pages/Anonymous/InviteUsersPage";
import { LoginPage } from "../../pages/Anonymous/LoginPage";
import { LogoutPage } from "../../pages/Anonymous/LogoutPage";
import { NewAcocuntSetupPage } from "../../pages/NewAcocuntSetupPage";
import { NoFoundPage } from "../../pages/Anonymous/NoFoundPage";
import { PADAgreenmentPage } from "../../pages/PADAgreenmentPage";
import { PDFAxisPage } from "../../pages/PDFAxisPage";
import { PDFFilesPage } from "../../pages/PDFFilesPage";
import { ProtectedRoleRoutes } from "./ProtectedRoutes";
import { ResetPasswordPage } from "../../pages/Anonymous/ResetPasswordPage";
import { SecurityQuestionsScreenPage } from "../../pages/SecurityQuestionsScreenPage";
import { UploadDocumentsPage } from "../../pages/UploadDocumentsPage";
import { UserAccountSettingPage } from "../../pages/Anonymous/UserAccountSettingPage";
import { UserAuthenticationPage } from "../../pages/Anonymous/UserAuthenticationPage";
import { VerifyOtpPage } from "../../pages/Anonymous/VerifyOtpPage";
import { useSelector } from "react-redux";

// const LoginPage = React.lazy(() => import("../../pages/Anonymous/LoginPage").then(m => ({ default: m.LoginPage })));
// const VerifyOtpPage = React.lazy(() => import("../../pages/Anonymous/VerifyOtpPage").then(m => ({ default: m.VerifyOtpPage })));
// const NoFoundPage = React.lazy(() => import("../../pages/Anonymous/NoFoundPage").then(m => ({ default: m.NoFoundPage })));
// const CreateAnAccountPage = React.lazy(() => import("../../pages/Anonymous/CreateAnAccountPage").then(m => ({ default: m.CreateAnAccountPage })));
// const UserAuthenticationPage = React.lazy(() => import("../../pages/Anonymous/UserAuthenticationPage").then(m => ({ default: m.UserAuthenticationPage })));
// const ResetPasswordPage = React.lazy(() => import("../../pages/Anonymous/ResetPasswordPage").then(m => ({ default: m.ResetPasswordPage })));
// const LogoutPage = React.lazy(() => import("../../pages/Anonymous/LogoutPage").then(m => ({ default: m.LogoutPage })));
// const InviteUsersPage = React.lazy(() => import("../../pages/Anonymous/InviteUsersPage").then(m => ({ default: m.InviteUsersPage })));
// const PDFFilesPage = React.lazy(() => import("../../pages/PDFFilesPage").then(m => ({ default: m.PDFFilesPage })));
// const PDFAxisPage = React.lazy(() => import("../../pages/PDFAxisPage").then(m => ({ default: m.PDFAxisPage })));
// const Generate2FaQrPage = React.lazy(() => import("../../pages/Anonymous/Generate2FaQrPage").then(m => ({ default: m.Generate2FaQrPage })));
// const BackupCodeVerificationPage = React.lazy(() => import("../../pages/Anonymous/BackupCodeVerificationPage").then(m => ({ default: m.BackupCodeVerificationPage })));
// const AuthSelectionScreenPage = React.lazy(() => import("../../pages/Anonymous/AuthSelectionScreenPage").then(m => ({ default: m.AuthSelectionScreenPage })));
// const AddPhoneValidation = React.lazy(() => import("../../pages/Anonymous/AddPhoneValidation").then(m => ({ default: m.AddPhoneValidation })));
// const AuthSelectionScreenForLoginPage = React.lazy(() => import("../../pages/Anonymous/AuthSelectionScreenForLoginPage").then(m => ({ default: m.AuthSelectionScreenForLoginPage })));
// const UserAccountSettingPage = React.lazy(() => import("../../pages/Anonymous/UserAccountSettingPage").then(m => ({ default: m.UserAccountSettingPage })));


interface AppRouterProps {
	isAuthenticated: boolean;
}
export const AppRouter: React.FC<AppRouterProps> = ({ isAuthenticated }) => {
	const clientId = useSelector((state: IAppState) => state.client.id);
	const accountantId = useSelector((state: IAppState) => state.accountant.id);
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	const companyAccountantName = useSelector(
		(state: IAppState) => state.user.profile.companyAccountantName
	);
	const lastBankScreen = useSelector(
		(state: IAppState) => state.user.profile.lastBankScreen
	);
	const screenFirstPointForNonPrimaryUser = useSelector(
		(state: IAppState) => state.drawerMenu.screenFirstPoint
	);
	const originalMenu = useSelector(
		(state: IAppState) => state.drawerMenu.originalMenu
	);


	const getInitialRoutes = () => {
		if (isAdminUser === 400) return routes;

		if (isAdminUser === 100) {
			return companyAccountantName
				? superUserInitialAccountantSetupRoutes
				: superUserInitialClientListRoutes;
		}

		if (isAdminUser === 200) {
			return companyAccountantName
				? clientSetupDashboardInitialRoutes
				: clientDashboardInitialRoutes;
		}

		if (isAdminUser === 500) {
			switch (screenFirstPointForNonPrimaryUser) {
				case 100: return superUserInitialClientListRoutes;
				case 200: return nonSuperUserInitialRoutesIfAccAssign;
				case 300:
				case 400:
					return clientDashboardInitialRoutes;
			}
		}

		return initialLoadingPageWhileMenuIsGettingFromAPI;
	};


	return (
		// <Router basename="/simple-pay">
		//  <Router basename="https://appv3.simplepay.com">
		<Router>
			<Routes>
				<Route
					path="/"
					element={
						<PublicRoute isAuthenticated={isAuthenticated} redirectTo="/">
							<LoginPage />
							{/* <ProtectedRoutes routeList={ClientRoutes} /> */}
						</PublicRoute>
					}
				/>
				<Route
					path="/login"
					element={
						<PublicRoute isAuthenticated={isAuthenticated} redirectTo="/">
							<LoginPage />
							{/* <ProtectedRoutes routeList={ClientRoutes} /> */}
						</PublicRoute>
					}
				/>


				{/* ########################################### SIGN UP ############################################# */}
				<Route
					path="/phone-otp-validation"
					element={
						<PublicRoute isAuthenticated={isAuthenticated} redirectTo="/">
							<VerifyOtpPage />
						</PublicRoute>
					}
				/>
				<Route
					path="/google-auth-validation"
					element={
						<PublicRoute isAuthenticated={isAuthenticated} redirectTo="/">
							<Generate2FaQrPage />
						</PublicRoute>
					}
				/>
				<Route
					path="/backup-code-validation"
					element={
						<PublicRoute isAuthenticated={isAuthenticated} redirectTo="/">
							<BackupCodeVerificationPage />
						</PublicRoute>
					}
				/>
				<Route
					path="/add-phone-validation"
					element={
						<PublicRoute isAuthenticated={isAuthenticated} redirectTo="/">
							<AddPhoneValidation />
						</PublicRoute>
					}
				/>
				<Route
					path="/auth-selection-screen"
					element={
						<PublicRoute isAuthenticated={isAuthenticated} redirectTo="/">
							<AuthSelectionScreenPage />
						</PublicRoute>
					}
				/>
				<Route
					path="/auth-selection-screen-for-login"
					element={
						<PublicRoute isAuthenticated={isAuthenticated} redirectTo="/">
							<AuthSelectionScreenForLoginPage />
						</PublicRoute>
					}
				/>
				<Route
					path="/user-account-setting"
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<UserAccountSettingPage />
						</PrivateRoute>
					}
				/>
				<Route
					path="/create-an-account"
					element={
						<PublicRoute isAuthenticated={isAuthenticated} redirectTo="/">
							<CreateAnAccountPage />
						</PublicRoute>
					}
				/>
				<Route
					path="/security-questions"
					element={
						<PublicRoute isAuthenticated={isAuthenticated} redirectTo="/">
							<SecurityQuestionsScreenPage />
						</PublicRoute>
					}
				/>
				<Route
					path="/account-bank-details"
					element={
						<PublicRoute isAuthenticated={isAuthenticated} redirectTo="/">
							<AccountOrBankDetailsPage />
						</PublicRoute>
					}
				/>
				<Route
					path="/new-account-setup"
					element={
						<PublicRoute isAuthenticated={isAuthenticated} redirectTo="/">
							<NewAcocuntSetupPage />
						</PublicRoute>
					}
				/>
				<Route
					path="/pad-agreement"
					element={
						<PublicRoute isAuthenticated={isAuthenticated} redirectTo="/">
							<PADAgreenmentPage />
						</PublicRoute>
					}
				/>
				<Route
					path="/upload-documents"
					element={
						<PublicRoute isAuthenticated={isAuthenticated} redirectTo="/">
							<UploadDocumentsPage />
						</PublicRoute>
					}
				/>
				<Route
					path="/user-authentication/:key"
					element={
						<PublicRoute isAuthenticated={isAuthenticated} redirectTo="/">
							<UserAuthenticationPage />
						</PublicRoute>
					}
				/>
				{/* <Route
          path="/reset-password"
          element={
            <PublicRoute isAuthenticated={isAuthenticated} redirectTo="/">
              <ResetPasswordPage />
            </PublicRoute>
          }
        /> */}
				<Route
					index
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoutes
								routeList={
									// clientId !== ""
									// 	? clientDashboardInitialRoutes
									// 	: isAdminUser === 400 && accountantId !== ""
									// 		? superUserInitialClientListRoutes
									// 		: isAdminUser !== 400 && accountantId !== ""
									// 			? nonSuperUserInitialRoutes
									// 			: isAdminUser !== 400
									// 				? nonSuperUserInitialRoutesIfAccAssign
									// 				: routes
									isAdminUser === 400
										? routes
										: isAdminUser === 100 && companyAccountantName !== null
											// ? superUserInitialAccountantSetupRoutes
											? AccountiungProfessionalInitialRoutes
											: isAdminUser === 100 && companyAccountantName === null && lastBankScreen && lastBankScreen === 500
												// ? superUserInitialAccountantSetupRoutes
												? AccountiungProfessionalInitialRoutes
												: isAdminUser === 100 && companyAccountantName === null && lastBankScreen && lastBankScreen === 100
													? AccountiungProfessionalPADInitialRoutes
													: isAdminUser === 100 && companyAccountantName === null && lastBankScreen && lastBankScreen === 200
														? AccountiungProfessionalUDInitialRoutes
														: isAdminUser === 100 && companyAccountantName === null && lastBankScreen && lastBankScreen === 300
															? superUserInitialClientListRoutes
															: isAdminUser === 200 && companyAccountantName === null && lastBankScreen && lastBankScreen === 500
																? SingleCompanyInitialRoutes
																: isAdminUser === 200 && companyAccountantName !== null
																	? SingleCompanyInitialRoutes
																	: isAdminUser === 200 && companyAccountantName === null && lastBankScreen && lastBankScreen === 100
																		? AccountiungProfessionalPADInitialRoutes
																		: isAdminUser === 200 && companyAccountantName === null && lastBankScreen && lastBankScreen === 200
																			? AccountiungProfessionalUDInitialRoutes
																			: isAdminUser === 200 && companyAccountantName === null && lastBankScreen && lastBankScreen === 300
																				? clientDashboardInitialRoutes
																				: isAdminUser === 500 && screenFirstPointForNonPrimaryUser === 100
																					? superUserInitialClientListRoutes
																					: isAdminUser === 500 && screenFirstPointForNonPrimaryUser === 200
																						? nonSuperUserInitialRoutesIfAccAssign
																						: isAdminUser === 500 && screenFirstPointForNonPrimaryUser === 300
																							? clientDashboardInitialRoutes
																							: isAdminUser === 500 && screenFirstPointForNonPrimaryUser === 400
																								? clientDashboardInitialRoutes
																								// : isAdminUser === 300
																								// 	? clientDashboardInitialRoutes
																								: initialLoadingPageWhileMenuIsGettingFromAPI
								}
							/>
						</PrivateRoute>
					}
				/>
				<Route
					path={isAdminUser === 400 ? "/global-search/*" : "/"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={GlobalSearchRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path={"/accountants/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={AccountantsRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path={"/direct-deposit/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={DirectDepositRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path={"/workplace-safety/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={WorkplaceSafetyRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path="/country/*"
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={CountryRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path="/province/*"
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={ProvinceRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path="/state/*"
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={StateRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path="/tax-profile/*"
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={TaxProfileRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path="/global-variables/*"
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={GlobalVariablesRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path="/tax-year/*"
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={TaxYearRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path="/roles/*"
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={DataRoleRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path={isAdminUser === 400 ? "/pdf-settings/*" : "/"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={PDFSettingsRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path={"/forms/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={TD1FormRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path={"/bank/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={BankRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path={"/city/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={CityRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path={"/branch/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={BranchRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path={"/minimum-wage-rate/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={MinimumWageRateRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path={"/news/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={NewsRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path={"/web-roe/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={WebROESubmissionRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path={"/role-management/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={RoleManagementRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path={"/payroll-earning/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={PayrollEarningsRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path={"/payroll-federal-taxable-earning/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={PayrollFederalEarningsRoutes} />
						</PrivateRoute>
					}
				/>

				<Route
					path={"/payroll-insurable-earning/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={PayrollInsurableEarningsRoutes} />
						</PrivateRoute>
					}
				/>

				<Route
					path={"/payroll-pensionable-earning/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={PayrollPensionableEarningsRoutes} />
						</PrivateRoute>
					}
				/>

				<Route
					path={"/payroll-wcb-wsib-earning/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={PayrollWCBWSIBEarningsRoutes} />
						</PrivateRoute>
					}
				/>

				<Route
					path={"/payroll-provincial-taxable-earning/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={PayrollProvincialTaxableEarningsRoutes} />
						</PrivateRoute>
					}
				/>

				<Route
					path={"/payroll-holiday-earning/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={PayrollHolidayEarningsRoutes} />
						</PrivateRoute>
					}
				/>

				<Route
					path={"/payroll-vocational-earning/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={PayrollVocationalEarningsRoutes} />
						</PrivateRoute>
					}
				/>

				<Route
					path={"/payroll-qpip-earning/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={PayrollQPIPEarningsRoutes} />
						</PrivateRoute>
					}
				/>

				<Route
					path={"/payroll-csst-earning/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={PayrollCSSTEarningsRoutes} />
						</PrivateRoute>
					}
				/>

				<Route
					path={"/payroll-hsf-earning/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={PayrollHSFEarningsRoutes} />
						</PrivateRoute>
					}
				/>

				<Route
					path={"/payroll-eht-earning/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={PayrollEHTEarningsRoutes} />
						</PrivateRoute>
					}
				/>

				<Route
					path={"/statutory-holiday/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={StatutoryHolidayRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path={"/bc-eht-setting/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={BCEHTSettingRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path={"/billing-profile/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={BillingProfileRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path={"/billing-profile-association/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={BillingProfileAssociationRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path={"/voucher/*"}
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={VouchersRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path="/clients/*"
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={ClientRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path="/employee/*"
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={EmployeeRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path="/payroll/*"
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={PayrollRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path="/company/*"
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={CompanyRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path="/compliance/*"
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={ComplianceRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path="/td1/*"
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={TD1Routes} />
						</PrivateRoute>
					}
				/>
				<Route
					path="/reports/*"
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							{/* <RoleRouteGuard menuList={originalMenu}> */}
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={ReportsRoutes} />
							{/* </RoleRouteGuard> */}
						</PrivateRoute>
					}
				/>
				<Route
					path="/taxes/*"
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={TaxesRoutes} />
						</PrivateRoute>
					}
				/>
				<Route
					path="/add-ons/*"
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							{/* <RoleRouteGuard menuList={originalMenu}> */}
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={AddOnsRoutes} />
							{/* </RoleRouteGuard> */}
						</PrivateRoute>
					}
				/>
				<Route
					path="/settings/*"
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={SettingsRoutes} />
						</PrivateRoute>
					}
				/>

				<Route
					path="/forgot-password/*"
					element={
						<PublicRoute
							isAuthenticated={isAuthenticated}
							redirectTo="/forgot-password"
						>
							{/* <ForgotPasswordPage /> */}
							<ProtectedRoleRoutes menuList={originalMenu} isAdminUser={isAdminUser} routeList={ForgetPasswordRoutes} />
						</PublicRoute>
					}
				/>

				<Route
					path="/invite/user"
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<InviteUsersPage />
						</PrivateRoute>
					}
				/>
				<Route
					path="/logout"
					element={
						<PrivateRoute isAuthenticated={isAuthenticated} redirectTo="/login">
							<LogoutPage />
						</PrivateRoute>
					}
				/>
				<Route path="*" element={<NoFoundPage />} />
			</Routes>
		</Router>
	);
};
